import { useEffect, useState } from "react";
import { useThemeMode } from "@/lib/theme";
import { CodeBlock } from "@/components/docs/CodeBlock";

let counter = 0;

const DARK_VARS = {
  darkMode: true,
  fontSize: "14px",
  background: "#111827",
  primaryColor: "#1F2937",
  primaryTextColor: "#F9FAFB",
  primaryBorderColor: "#3B82F6",
  secondaryColor: "#0D1322",
  tertiaryColor: "#0D1322",
  lineColor: "#6B7280",
  textColor: "#E5E7EB",
  clusterBkg: "#0D1322",
  clusterBorder: "#374151",
  edgeLabelBackground: "#111827",
  actorBkg: "#1F2937",
  actorBorder: "#3B82F6",
  actorTextColor: "#F9FAFB",
  signalColor: "#9CA3AF",
  signalTextColor: "#E5E7EB",
  noteBkgColor: "#422006",
  noteTextColor: "#FDE68A",
  noteBorderColor: "#F59E0B",
  labelBoxBkgColor: "#1F2937",
  labelTextColor: "#F9FAFB",
  loopTextColor: "#E5E7EB",
};

export const MermaidDiagram = ({ code, testId }) => {
  const { theme } = useThemeMode();
  const [svg, setSvg] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    import("mermaid").then(async ({ default: mermaid }) => {
      mermaid.initialize({
        startOnLoad: false,
        securityLevel: "strict",
        theme: theme === "dark" ? "base" : "neutral",
        themeVariables: theme === "dark" ? DARK_VARS : { fontSize: "14px" },
        fontFamily: "DM Sans, sans-serif",
      });
      try {
        counter += 1;
        const { svg: out } = await mermaid.render(`mmd-${counter}`, code);
        if (!cancelled) setSvg(out);
      } catch (e) {
        if (!cancelled) setError(String(e?.message || e));
      }
    });
    return () => {
      cancelled = true;
    };
  }, [code, theme]);

  if (error) {
    return (
      <div data-testid={`${testId}-error`}>
        <p className="mb-2 font-mono text-xs text-danger">Dijagram se nije mogao prikazati. Prikazujem izvor.</p>
        <CodeBlock code={code} language="text" testId={`${testId}-source`} />
      </div>
    );
  }

  return (
    <figure
      data-testid={testId}
      className="mermaid-figure my-6 overflow-x-auto rounded-lg border border-border bg-card p-4 sm:p-6"
      dangerouslySetInnerHTML={{ __html: svg || '<p class="text-sm text-muted-foreground">Crtam dijagram…</p>' }}
    />
  );
};
